import React from "react";
import icon from "../assets/icon.png";
import Navbar from "./Navbar";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import icon4 from "../assets/icon4.png";
import icon5 from "../assets/icon5.png";
import icon6 from "../assets/icon6.png";
import icon7 from "../assets/icon7.png";
import icon8 from "../assets/icon8.png";
import tebra from "../assets/tebra.png";
import simple from "../assets/SimplePra.png";
import next from "../assets/nextgen.png";
import advanced from "../assets/advanced md.png";
import azala from "../assets/azala.png";
import clinic from "../assets/clinical.png";
import colab from "../assets/colaborate.png";
import popo from "../assets/populate.png";
import group2 from "../assets/gr.webp";
import group from "../assets/Group-1.png";
import gear from "../assets/gear.png";
import check from "../assets/checklist.png";
import work from "../assets/workplace.png";
import x from "../assets/x.png";
import lady from "../assets/lady.webp";
import iconcheck from "../assets/iconcheck.png";
import map from "../assets/map.webp";
import ainak from "../assets/Ainak.webp";
import ico1 from '../assets/ico1.jpg';
import ico2 from '../assets/ico2.jpg';
import ico3 from '../assets/ico3.jpg';
import ico4 from '../assets/ico4.jpg';
import ico5 from '../assets/ico5.jpg';
import ico6 from '../assets/ico6.jpg';
import Footer from "./Footer";
import Medical from './Medical';
import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import ScrollToTop from '../Components/Scroll.js'
import { useRef, useEffect } from "react";

// Card Component
const Card = ({ number, title, content, linkColor }) => {
  return (
    <div className="relative min-w-[320px] h-[440px] shadow-[inset_5px_5px_5px_rgba(0,0,0,0.2),inset_-5px_-5px_15px_rgba(255,255,255,0.1),5px_5px_15px_rgba(0,0,0,0.3),-5px_-5px_15px_rgba(255,255,255,0.1)] rounded-[15px] m-[30px] transition-transform duration-500">
      <div className="absolute top-[20px] left-[20px] right-[20px] bottom-[20px] bg-[#2a2b2f] rounded-[15px] flex justify-center items-center overflow-hidden transition-transform duration-500 hover:-translate-y-[50px]">
        <div className="relative p-[20px] text-center">
          <h2 className="absolute top-[-10px] right-[30px] text-[8rem] text-[rgba(255,255,255,0.1)]">
            {number}
          </h2>
          <h3 className="text-[1.8rem] text-white mb-[15px] z-10 transition-all duration-500">
            {title}
          </h3>
          <p className="text-[1rem] font-light text-[rgba(255,255,255,0.9)] z-10 transition-all duration-500">
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};



const LandingPage = () => {

  
  

  const Card = ({ number, title, content, linkColor }) => {
    return (
      <div className="relative min-w-[320px] h-[440px] shadow-[inset_5px_5px_5px_rgba(0,0,0,0.2),inset_-5px_-5px_15px_rgba(255,255,255,0.1),5px_5px_15px_rgba(0,0,0,0.3),-5px_-5px_15px_rgba(255,255,255,0.1)] rounded-[15px] m-[30px] transition-transform duration-500 fadi-in">
        <div className="absolute top-[20px] left-[20px] right-[20px] bottom-[20px] bg-[#2a2b2f] rounded-[15px] flex justify-center items-center overflow-hidden transition-transform duration-500 hover:-translate-y-[50px]">
          <div className="relative p-[20px] text-center">
            <h2 className="absolute top-[-10px] right-[30px] text-[8rem] text-[rgba(255,255,255,0.1)]">
              {number}
            </h2>
            <h3 className="text-[1.8rem] text-white mb-[15px] z-10 transition-all duration-500">
              {title}
            </h3>
            <p className="text-[1rem] font-light text-[rgba(255,255,255,0.9)] z-10 transition-all duration-500">
              {content}
            </p>
            {/* <a 
            href="#" 
            className={relative inline-block px-[20px] py-[8px] bg-[${linkColor}] rounded-[5px] text-white mt-[20px] shadow-[0_10px_20px_rgba(0,0,0,0.2)] transition-all duration-500 hover:shadow-[0_10px_20px_rgba(0,0,0,0.6)] hover:bg-white hover:text-black}
          >
            Read More
          </a> */}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Navbar></Navbar>
      <div
        className="flex flex-col lg:flex-row bg-cyan-100 p-8"
        style={{ backgroundImage: `url(${require("../assets/Group-bg.png")})` }}
      >
        {/* <!-- Left Section: Text and Button --> */}
        <div className="flex-1 mr-0 lg:mr-8 mb-8 lg:mb-0">
          <h1 className="font-sans font-bold text-blue-900 text-4xl break-words ml-4 pt-10">
            Maximize Revenue with Cutting-Edge Medical Billing Services
          </h1>
          <p className="font-sans text-lg text-teal-900 break-words ml-4 pt-5">
            Optimize revenue cycles with our comprehensive medical billing
            services, ensuring accuracy, efficiency, and maximized
            reimbursements for your medical practice.
          </p>
          <div className="mt-9">
            <NavLink
              to="/Contact"
              className="button-86 "
            >
              Get Quote Now
            </NavLink>
          </div>
        </div>

        {/* <!-- Right Section: Image --> */}
        <div className="flex-1">
          <img src={group} className="w-full h-auto" />
        </div>
      </div>
      <div className="w-full bg-gray-400 py-4 px-2">
  <div className="flex flex-wrap items-center justify-center gap-5">
    {/* First Item */}
    <div className="flex items-center space-x-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-6 h-6 text-green-700"
      >
        <path d="M7.493 18.5c-.425 0-.82-.236-.975-.632A7.48 7.48 0 0 1 6 15.125c0-1.75.599-3.358 1.602-4.634.151-.192.373-.309.6-.397.473-.183.89-.514 1.212-.924a9.042 9.042 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75A.75.75 0 0 1 15 2a2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H14.23c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23h-.777ZM2.331 10.727a11.969 11.969 0 0 0-.831 4.398 12 12 0 0 0 .52 3.507C2.28 19.482 3.105 20 3.994 20H4.9c.445 0 .72-.498.523-.898a8.963 8.963 0 0 1-.924-3.977c0-1.708.476-3.305 1.302-4.666.245-.403-.028-.959-.5-.959H4.25c-.832 0-1.612.453-1.918 1.227Z" />
      </svg>
      <p className="font-semibold text-base sm:text-lg text-green-950 text-center">
        100+ Satisfied Providers Across 50 States
      </p>
    </div>

    {/* Second Item */}
    <div className="flex items-center space-x-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-6 h-6 text-green-700"
      >
        <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
      </svg>
      <p className="font-semibold text-base sm:text-lg text-green-950 text-center">
        Serving 150+ Medical Specialities
      </p>
    </div>

    {/* Third Item */}
    <div className="flex items-center space-x-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="w-6 h-6 text-green-700"
      >
        <path
          fillRule="evenodd"
          d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z"
          clipRule="evenodd"
        />
      </svg>
      <p className="font-semibold text-base sm:text-lg text-green-950 text-center">
        100+ Certified Billing + Coding Experts
      </p>
    </div>
  </div>
</div>


<div className="flex flex-col lg:flex-row gap-8 px-4 lg:px-12 items-center">
  {/* Text Content */}
  <div className="flex-1 flex flex-col justify-between h-full"> 
    <h1 className="font-bold text-5xl lg:text-5xl text-indigo-900 pt-5 break-words">
      Axion-USA’s Premium Medical Billing Consultancy Company
    </h1>
    <p className="text-black text-lg pt-5 font-sans font-medium break-words leading-relaxed">
      Our medical billing company is based in 3466 Crayrich Dr, Birmingham. We
      are offering end-to-end medical billing and coding services to
      healthcare establishments all over the USA. Our experience expands
      over more than a decade of perfection and unparalleled results. We
      provide customized solutions to each medical specialty addressing
      critical issues causing low collections. Our complete revenue cycle
      management services help increase revenue by many folds. We are an
      ISO certified and HIPAA-compliant company helping your practice meet
      regulatory compliance. Providers can leverage our expertise and
      professional insights for optimal results in patient care.
    </p>
    <div className="mt-6"> 
      <NavLink
        to="/About"
        className="button-86 relative w-[100px] h-[30px] text-[16px] text-gray-100 cursor-pointer p-[10px_20px] flex items-center justify-center whitespace-nowrap select-none transition-all duration-400 ease-in-out"
      >
        About Us
      </NavLink>
    </div>
  </div>

  {/* Image */}
  <div className="flex-1 flex justify-center items-center">
    <img
      src={group2}
      className="w-full max-w-sm lg:max-w-md rounded-2xl hover:blur-none transition duration-300"
      alt="Image description"
    />
  </div>
</div>


      <div className="text-center px-4 py-16 ">
        <h1 className="font-bold text-3xl md:text-4xl lg:text-5xl leading-tight">
          Our Tailored Medical Billing
        </h1>
        <span className="font-bold text-3xl md:text-4xl lg:text-5xl text-gray-600 block mt-2">
          Services For You
        </span>
        <p className="text-black text-lg pt-5 font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
          Axion Medical Billing Services comprises complete solutions helping
          healthcare practitioners in navigating complexities of medical billing
          and revenue cycle management. Our medical billing specialist helps you
          rise to the overwhelming challenges in ensuring healthcare providers
          focus on their core responsibilities which is patient care.
        </p>
      </div>
      {/* CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {/* <!-- Card 1 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Medical Billing Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                We offer customized solutions that fit your requirements
              </h1>
            </div>
          </div>
        </div>

        {/* <!-- Card 2 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon2} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Medical Coding Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Accrurate medical coding services ensure complete compliance
                with ICD-10 and CPT Standards.
              </h1>
            </div>
          </div>
        </div>

        {/* <!-- Card 3 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon3} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Prior Authorization Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Streamlined prompt prior authorixation services ensure swift
                approvals and optimum patient care.
              </h1>
            </div>
          </div>
        </div>

        {/* <!-- Card 4 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon4} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Virtual Medical Assistant
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Enhance efficiency and improve patient care by 24/7
                cost-effective virtual medical help desk.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 5 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon5} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Medical Credentialing Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Meet Industry's standards set by regulatory bodies for
                maintaining licensure and accreditation.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 6 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon6} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Denial Management Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Rapidly resolve claim denials and their timely solution to
                increase patient revenue.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 7 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon7} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Insurance Eligibilty Services
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Improve patient satisfaction and reduce denials effortlessly by
                using reliable verification services.
              </h1>
            </div>
          </div>
        </div>
        {/* <!-- Card 8 --> */}
        <div className="flip-card w-full h-64">
          <div className="flip-card-inner">
            <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
              <img src={icon8} className="h-16 mx-auto" alt="Icon" />
              <p className="mt-2 font-medium text-lg md:text-xl text-center">
                Health Care Data Analytic
              </p>
            </div>
            <div className="flip-card-back bg-blue-600 text-white p-4 rounded-lg shadow-lg flex items-center justify-center">
              <h1 className="font-mono text-xl md:text-xl text-center">
                Data driven insights comprehensive reporting, enhancing patient
                outcomes, empowering informed decisions making.
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center px-4 mt-10 bg-yellow-100">
        <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-indigo-950 leading-tight">
          Our Expertise On Medical
        </h1>
        <span className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-gray-600 block mt-2">
          Billing Software
        </span>
        <p className="text-black text-lg pt-5 font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
          Axion’s medical billing software streamlines the billing workflow at
          all stages of claim generation to submission. Our health claim billing
          software efficiently performs claim scrubbing and submissions, coding,
          denial resolution, centralized billing, and advanced analytics, as
          well as payment processing, to strengthen your healthcare revenue
          cycle.
        </p>
      </div>
      <div className="px-4 mx-auto max-w-full">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {/* Card 1 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={tebra} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
          {/* Card 2 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={simple} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
          {/* Card 3 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={next} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
          {/* Card 4 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={advanced} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
          {/* Card 5 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={azala} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
          {/* Card 6 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={clinic} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
          {/* Card 7 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={colab} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
          {/* Card 8 */}
          <div className="flip-card1 w-full h-64">
            <div className="flip-card-inner">
              <div className="flip-card-front bg-[#ede8f5] p-4 rounded-lg shadow-lg">
                <img src={popo} className="mx-auto" alt="Icon" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="h-auto w-full bg-gradient-to-r from-yellow-400 to-sky-400 mt-10">
        <div className="text-center px-4 mt-10">
          <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white leading-tight">
            Benefits of our Medical Billing
          </h1>
          <span className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-gray-200 block mt-2">
            Services For Healthcare Providers
          </span>
          <span className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-gray-200 block mt-2">
            Providers
          </span>
          <div className="text-center px-4 sm:px-6 md:px-8">
            <p className="text-white text-lg pt-5 font-sans font-medium leading-relaxed break-words">
              The benefits we offer to physicians are unparalleled in the
              industry.
            </p>
            <span className="text-white text-lg font-sans font-medium leading-relaxed block mt-2">
              These unique and custom-fit solutions for every practice erase
              financial troubles in a snap.
            </span>
          </div>
        </div>
        <div className="flex flex-wrap justify-center gap-6 p-4">
          {/* First Card */}
          <div className="group border-2 border-white w-80 h-auto flex flex-col items-center justify-center text-center p-4 transition-all duration-300 hover:shadow-[0_0_15px_5px_rgba(255,255,255,0.6)]">
            {/* Icon Image */}
            <img
              src={gear}
              alt="Gear Icon"
              className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain mb-4"
            />
            {/* Heading */}
            <h1 className="text-white text-xl font-bold mb-2">
              Skilled and Talented Team
            </h1>
            {/* Paragraph */}
            <p className="text-white text-sm sm:text-lg pt-1 font-sans font-medium leading-relaxed break-words">
              We offer you a billing team that is highly qualified and
              understands your practice’s needs. Their empathic way of thinking
              helps to maximize a healthcare facility’s optimal potential. They
              help you grow revenue and patients by giving the best medical care
              and getting paid for it.
            </p>
          </div>

          {/* Second Card */}
          <div className="group border-2 border-white w-80 h-auto flex flex-col items-center justify-center text-center p-4 transition-all duration-300 hover:shadow-[0_0_15px_5px_rgba(255,255,255,0.6)]">
            <img
              src={check}
              alt="Check Icon"
              className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain mb-4"
            />
            <h1 className="text-white text-xl font-bold mb-2">
              Less Mistakes than In-house Staff
            </h1>
            <p className="text-white text-sm sm:text-lg pt-1 font-sans font-medium leading-relaxed break-words">
              The best thing a physician needs is mistake-free billing. We know
              in-house staff are overburdened, so they are prone to making
              costly mistakes. On the other hand, the dedicated staff of
              Medheave has achieved excellence in error-free claims. We help you
              reduce such roadblocks to fair earnings.
            </p>
          </div>

          {/* Third Card */}
          <div className="group border-2 border-white w-80 h-auto flex flex-col items-center justify-center text-center p-4 transition-all duration-300 hover:shadow-[0_0_15px_5px_rgba(255,255,255,0.6)]">
            <img
              src={work}
              alt="Work Icon"
              className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain mb-4"
            />
            <h1 className="text-white text-xl font-bold mb-2">
              Lower Administrative Expenses
            </h1>
            <p className="text-white text-sm sm:text-lg pt-1 font-sans font-medium leading-relaxed break-words">
              Every month, providers spend a significant amount of their
              earnings on in-house administrative staff’s remuneration.
              Outsourcing the billing tasks to a certified team decreases these
              costs by as much as up to 60%. This valuable saving helps
              providers maintain the financial stability of their clinic,
              hospital, etc.
            </p>
          </div>

          {/* Fourth Card */}
          <div className="group border-2 border-white w-80 h-auto flex flex-col items-center justify-center text-center p-4 transition-all duration-300 hover:shadow-[0_0_15px_5px_rgba(255,255,255,0.6)]">
            <img
              src={x}
              alt="X Icon"
              className="w-12 h-12 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 object-contain mb-4"
            />
            <h1 className="text-white text-xl font-bold mb-2">
              Appropriate Denial Management
            </h1>
            <p className="text-white text-sm sm:text-lg pt-1 font-sans font-medium leading-relaxed break-words">
              Claim denials are bad debt if not given attention. Our designated
              billing managers track each case with top priority. Every case is
              investigated under the microscope, and appropriate measures are
              applied for future proofing. We help you recover claim denials in
              less time than others.
            </p>
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center mt-24">
        {/* Image on the left */}
        <div className="mb-6 md:mb-0 md:w-1/2">
          <img src={lady} alt="Lady" className="w-full h-auto" />
        </div>

        {/* Content on the right */}
        <div className="space-y-4 md:w-1/2 md:pl-8">
          <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-indigo-950 leading-tight">
            Reasons Why to Choose Us{" "}
          </h1>
          <p className="text-black text-lg pt-5 font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
            We are your best option to avoid mistakes in patient billing and
            increasing revenue. Medheave medical billing services comprise
            industry’s experts and best practices. By hiring us, you enter in
            the world of endless possibilities.
          </p>

          <div className="space-y-2">
            {" "}
            {/* Reduced vertical space between items */}
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                Providers get the best value for money
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                Economical, feasible for small and large practices
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                Reduces your healthcare staff’s workload
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                Quick recovery of claims and aging accounts
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                Friendly and supportive team
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                Suitable to all medical specialties (consultation, surgical
                procedures, etc)
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                HIPAA certified, following latest ICD-10, CPT guidelines
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <img src={iconcheck} alt="icon" className="w-6 h-6" />
              <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-8">
                365 days availability for all medical practices (ER, Urgent
                care)
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center md:items-start bg-slate-200 p-4 md:p-8">
        {/* <!-- Text Section --> */}
        <div className="md:w-1/2 w-full text-center md:text-left mb-6 md:mb-0">
          <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-indigo-950 leading-tight mb-4">
            Availability Throughout The USA
          </h1>
          <p className="text-black text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-0 mt-4">
            Axion is a household name in medical billing services across all
            the 50 states of the USA. With a certified and skilled team, we help
            providers in optimizing their revenue to the maximum level. Our
            services are available in the following states and cities:
          </p>
          {/* <!-- Table Section --> */}
          <div className="mt-8">
            <div className=" grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 p-4">
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950 ">
                Massachusetts
              </div>
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                Connecticut
              </div>
              <div className="border border-gray-400 rounded-md  flex items-center justify-center h-24 font-bold text-indigo-950">
                Vermont
              </div>
              <div className="border border-gray-400  rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                Maine
              </div>
              <div className="border border-gray-400  rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                Texas
              </div>
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                Rhode Island
              </div>
              <div className="border border-gray-400  rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                New Hamsphire{" "}
              </div>
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                California
              </div>
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                New York
              </div>
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                New Jersey
              </div>
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                Michigan
              </div>
              <div className="border border-gray-400 rounded-md flex items-center justify-center h-24 font-bold text-indigo-950">
                Florida
              </div>
            </div>
          </div>
        </div>
        {/* 
  <!-- Image Section --> */}
        <div className="md:w-1/2 w-full flex justify-center md:justify-end">
          <img
            src={map}
            alt="USA Map"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
          />
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center md:items-start  p-4 md:p-8">
        {/* <!-- Image Section --> */}
        <div className="md:w-1/2 w-full flex justify-center md:justify-start mb-6 md:mb-0">
          <img
            src={ainak}
            alt="Emergency Room"
            className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg object-contain"
          />
        </div>

        {/* <!-- Text Section --> */}
        <div className="md:w-1/2 w-full text-center md:text-left">
          <h1 className="font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-indigo-950 leading-tight mb-4">
            Emergency Room Billing Services
          </h1>
          <p className="text-black  text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-0 mt-4">
            ER Billing Services is an integral part of Healthcare’s RCM. Manage
            your emergency room billing and coding to streamline critical care
            and mistake-free ER claims.
          </p>
          <div className="mt-9">
            <NavLink
              to="/Medical"
              className="button-86 relative w-[100px] h-[30px] text-[16px] text-gray-100 cursor-pointer p-[10px_20px] flex items-center justify-center whitespace-nowrap select-none transition-all duration-400 ease-in-out"
            >
              More
            </NavLink>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center md:items-start p-4 md:p-8">
  {/* Left Side Content */}
  <div className="md:w-1/2 p-4">
    <h1 className="font-bold text-5xl lg:text-5xl text-indigo-900 pt-5 break-words">
      Our Specialty Medical Billing Services
    </h1>
    <p className="text-black  text-lg font-sans font-medium break-words leading-relaxed px-4 sm:px-6 md:px-0 mt-4">
      We offer medical billing solutions custom-made for each medical specialty, 
      understanding the lack of skilled specialty coders and billers in the industry. 
      We meet the strict healthcare regulations and higher adherence resulting in a smooth 
      workflow optimizing all aspects of your revenue cycle. Our all-encompassing specialty 
      medical billing solutions are tailored for the following specialties.
    </p>
    <div className="mt-6">
      <NavLink
        to="/Speciality"
        className="button-86 relative w-[100px] h-[30px] text-[16px] text-gray-100 cursor-pointer p-[10px_20px] flex items-center justify-center whitespace-nowrap select-none transition-all duration-400 ease-in-out"
      >
        All Specialties
      </NavLink>
    </div>
  </div>

  {/* Right Side Cards */}
  <div className="grid grid-cols-2 gap-4 md:w-1/2 p-4">
    {/* Card 1 */}
    <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
  <img
    src={ico1}
    alt="Icon"
    className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
  />
  <h2 className="text-lg font-bold">Mental Health</h2>
</div>

    {/* Card 2 */}
    <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
  <img
    src={ico2}
    alt="Icon"
    className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
  />
  <h2 className="text-lg font-bold">Podiatry</h2>
</div>

    {/* Card 3 */}
    <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
  <img
    src={ico3}
    alt="Icon"
    className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
  />
  <h2 className="text-lg font-bold">Internal Medicine</h2>
</div>

    {/* Card 4 */}
    <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
  <img
    src={ico4}
    alt="Icon"
    className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
  />
  <h2 className="text-lg font-bold">Family Practice Billing</h2>
</div>

    {/* Card 5 */}
    <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
  <img
    src={ico5}
    alt="Icon"
    className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
  />
  <h2 className="text-lg font-bold">Urgent Care</h2>
</div>

    {/* Card 6 */}
    <div className="border border-gray-200 rounded-lg shadow-sm p-4 flex flex-col items-center text-center">
  <img
    src={ico6}
    alt="Icon"
    className="w-16 h-16 md:w-20 md:h-20 object-contain mb-2"
  />
  <h2 className="text-lg font-bold">Pediatrics</h2>
</div>

  </div>
</div>

<ScrollToTop />
      <Footer></Footer>
    </div>
  );
};

export default LandingPage;
